import { FormGroup } from '@angular/forms';

export class LiValidators {
    /**
     * Validator for forms that checks two controls to match. i.e password and confirm password
     *
     * @param {string} controlName The first control name
     * @param {string} matchingControlName The control name to match controlName
     * @returns {any} Validator result for FormGroups
     */
    static mustMatch(controlName: string, matchingControlName: string): any {
        return (signupForm: FormGroup) => {
            const control = signupForm.controls[controlName];
            const matchingControl = signupForm.controls[matchingControlName];
            if (
                matchingControl.errors &&
                !matchingControl.errors['mustMatch']
            ) {
                return;
            }
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            } else {
                matchingControl.setErrors(null);
            }
        };
    }
}
